export default "__VITE_ASSET__BgNKlXOy__"